import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms',
)({
  loader: () => ({ breadcrumbTitle: 'Forms' }),
})
